// extracted by mini-css-extract-plugin
export default {"content":"SJ-z","lookName":"TJ-z","shopTheLookContainer":"UJ-z","productContainer":"VJ-z","imageContainer":"WJ-z","mainImage":"XJ-z"};